function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.03093 15.0309C1.23718 14.9896 1.34528 15.0309 1.03093 15.0309C1.56148 15.0309 1.66958 14.9896 2.03093 15.0309L8.03093 9.03093L14.0309 15.0309C14.3923 14.9897 14.5004 15.0309 15.0309 15.0309C14.7166 15.0309 14.8247 14.9897 15.0309 15.0309C15.0722 14.7423 15.0722 14.4748 15.0309 14.0309L9.03093 8.03093L15.0309 2.03093C15.0722 1.58706 15.0722 1.31963 15.0309 1.03093C14.7423 0.989689 14.4748 0.989689 14.0309 1.03093L8.03093 7.03093L2.03093 1.03093C1.58706 0.989757 1.31963 0.989757 1.03093 1.03093C0.989689 1.31967 0.989689 1.58713 1.03093 2.03093L7.03093 8.03093L1.03093 14.0309C0.989723 14.4748 0.989723 14.7422 1.03093 15.0309Z",
  fill: "#44565A",
  stroke: "#44565A",
  strokeWidth: 0.5
});
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.084fd479.svg";
export { ForwardRef as ReactComponent };